
import { VideoFeatures } from './types';
import { defaultSalesNotification } from './types/sales-notification';
import { defaultHeadlineOverlay } from './types/headline-overlay';
import { defaultSyncActionsConfig } from './types/sync-actions';
import { defaultFinalCountdown } from './types/final-countdown';
import { defaultMiniHookSettings } from './types/mini-hook';
import { defaultConversionJourney } from './types/conversion-journey';
import { defaultVideoFeedback } from './types/video-feedback';


export const initialState: VideoFeatures = {
  actionButtons: [],

  autoPlay: false,
  showControls: false,
  showProgressBar: false,
  loop: false,
  disableControls: false,
  headlineVisible: false,
  headline: defaultHeadlineOverlay,

  // Player Theme (disabled by default)
  playerThemeEnabled: false,

  // Barra de controles inferior
  controlBarEnabled: false,
  controlBarColor: 'rgba(135, 145, 163, 0.45)',

  // Tema dos controles (afeta TODOS os ícones do player)
  controlsTheme: 'minimal',

  // All controls disabled by default
  skipForward: false,
  rewind: false,
  volumeControl: false,
  showCurrentTime: false,
  fullScreen: false,
  smallPlayButton: false,
  bigPlayButton: false,
  noneControlsMoreAutoplay: false,
  // hideControlsBeforeStart: false, // Removido - não implementado no player
  blockPause: false,
  pictureInPicture: false,
  tvCastEnabled: false,
  storyboardEnabled: false,
  playbackSpeedControl: false,
  speedTests: [],
  autoplayOverlay: {
    enabled: false,

    // Tipo de autoplay (lógica)
    autoplayType: 'same-video',
    alternateVideoId: undefined,
    alternateVideoName: undefined,
    alternateVideoThumbnail: undefined,
    alternateVideoDuration: undefined,

    // Minutagem
    clipStart: 0,
    clipEnd: undefined,

    // NOVO: Estilo do Fundo
    backgroundStyle: 'darkened',
    backgroundIntensity: 65,

    // NOVO: Tipo de Ícone
    iconType: 'sound',

    // Textos (vazios por padrão - defaults aplicados apenas no player)
    textTop: '',
    textBottom: '',
    showIcon: true,

    // Visual
    pulseAnimation: false,
    pulseEffect: false,
    whiteBorder: false,
    autoRestart: false,
    // Detectar Interação vem desativado por padrão (só liga se salvo como true).
    detectInteraction: false,
    // Clique Automático vem desativado por padrão (só liga se salvo como true).
    autoClick: false,
    // Tela flutuante (PiP) do autoplay — desativada por padrão.
    havePictureInPicture: false,
    useTemplate: true,
    templateId: 'autoPlay', // Template padrão do projeto original
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: '400',
    roundedCorners: true,
    showBorder: false,

    // Cores (do template padrão autoPlay)
    colors: {
      background: 'rgba(0, 170, 255, 0.46)', // #00AAFF75
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: '#FFFFFF'
    },

    // Teste A/B
    abTestConfig: {
      enabled: false,
      variations: [],
      selectedTemplates: [],
      trafficDistribution: {},
      variantTrafficDistribution: {},
      status: 'draft',
      isRealTimeEnabled: false,
      lastUpdated: ''
    }
  },
  continueWatching: {
    enabled: false,
    threshold: 5,
    expires: 7,
    message: 'Você parou em um ponto importante do vídeo.',
    buttonText: 'Continuar agora',
    restartText: 'Reiniciar vídeo'
  },
  continueWatchingOverlay: {
    backgroundColor: '#0E0E0E',
    textColor: '#FFFFFF',
    buttonColor: '#1D4FFF',
    buttonTextColor: '#FFFFFF',
    blurBackground: true,
    showTime: true,
    position: 'center',
    enabled: false,
    title: 'Retomar reprodução',
    message: 'Você parou em um ponto importante do vídeo.',
    continueText: 'Continuar agora',
    restartText: 'Reiniciar vídeo',
    overlayOpacity: 75,
    animationEntrance: 'fade',
    size: 'small',
    template: 'template1',
    useTemplate: true,
    autoResume: {
      enabled: false,
      delay: 5,
      showCountdown: true
    },
    soundAlert: {
      enabled: false,
      type: 'click'
    }
  },
  audience: {
    enabled: false,
    viewersCount: 150,
    message: '',
    style: {
      textColor: '#ffffff',
      backgroundColor: '#000000',
      useTransparency: true,
      opacity: 70
    }
  },
  salesNotification: defaultSalesNotification, // ✅ defaultSalesNotification já tem enabled: false

  // Border (simplified)
  border: {
    enabled: false,
    color: '#ffffff',
    width: 2,
    radius: 8,
    secondaryColor: '#ffffff',
    stylePreset: 'none'
  },
  // Control colors for backend
  controlColor: 'rgba(135, 145, 163, 0.45)', // Cor padrão dos controles
  controlColorIcon: 'rgba(255, 255, 255, 1)', // Cor padrão dos ícones

  // Player Theme
  playerColors: {
    primary: '#FFFFFF',
    secondary: '#64748B',
    backgroundColor: '#8791A3',
    borderRadius: 4,
    opacity: 0.45
  },

  // Smart Pause
  smartPause: false,

  // Legendas
  subtitles: [],
  subtitleConfig: {
    showByDefault: false,
    fontSize: '1em',
    fontColor: '#FFFFFF',
    backgroundColor: 'rgba(0,0,0,0.75)',
    textAlign: 'center',
    position: 'bottom',
    fontFamily: 'inherit',
    textShadow: false,
  },

  // Sync Actions
  syncActions: defaultSyncActionsConfig,

  // Final Countdown
  finalCountdown: defaultFinalCountdown,

  // Mini Hooks
  miniHooks: defaultMiniHookSettings,
  conversionJourney: defaultConversionJourney,

  // Feedback do Vídeo
  videoFeedback: defaultVideoFeedback,
};
